class VideoPopup extends HTMLElement {
    constructor() {
        super();
        this.thumbVideo = this.querySelector('.video-popup__thumb-video');
        this.fullVideoButton = this.querySelector('.video-popup__button');
        this.fullVideo = this.querySelector('.video-popup__full-video');
        this.fullVideoDialog = this.querySelector('.video-popup__dialog');
        this.dialogCloseArea = this.querySelector('.video-popup__close-area');
        this.dialogCloseButton = this.querySelector('.video-popup__close-button');
        this.flag = false;
        this.fullVideoInstance = null;
    }

    async connectedCallback() {
        if (this.thumbVideo) {
            const { VidstackPlayer: Player, VidstackPlayerLayout } = await import('https://cdn.vidstack.io/player@v1.11.30');
            setTimeout(() => {
                this.initThumbVideo(Player, VidstackPlayerLayout);
            }, 0);
            if (this.fullVideoButton) {
                this.fullVideoButton.addEventListener('click', (event) => {
                    this.initFullVideo(event, Player, VidstackPlayerLayout);
                });
                const closeDialogHandler = () => {
                    this.toggleDialog(false);
                    this.fullVideoInstance.pause();
                };

                this.dialogCloseArea.addEventListener('click', closeDialogHandler);
                this.dialogCloseButton.addEventListener('click', closeDialogHandler);
            }
        }
    }


    async initFullVideo(event, VidstackPlayer, VidstackPlayerLayout) {
        if (!this.thumbVideo) {
            console.error('Thumb video element not found');
            return;
        }
        if (!this.flag) {
            this.toggleDialog(true);
            const title = this.fullVideo.getAttribute('data-title');
            const videoSrc = this.fullVideo.getAttribute('data-src');
            const layout = new VidstackPlayerLayout({
                thumbnails: null,
            });
            try {
                const player = await VidstackPlayer.create({
                    target: this.fullVideo,
                    title: title,
                    controls: true,
                    loop: true,
                    src: videoSrc,
                    playsInline: true,
                    autoPlay: true,
                    layout
                });
                this.flag = true;
                this.fullVideoInstance = player;
            } catch (error) {
                console.error('Error creating player:', error);
            }
        } else {
            this.toggleDialog(true, true);
        }
    }


    toggleDialog(status, play) {
        if (status) {
            this.fullVideoDialog.classList.add('video-popup__dialog--visible');
            if (play) {
                this.fullVideoInstance.play();
            }
            document.body.style.overflow = 'hidden';
        } else {
            this.fullVideoDialog.classList.remove('video-popup__dialog--visible');
            document.body.style.overflow = '';
        }
    }

    async initThumbVideo(VidstackPlayer, VidstackPlayerLayout) {
        const title = this.thumbVideo.getAttribute('data-title');
        const matchMedia = window.matchMedia('(max-width: 749px)');
        let videoSrc = null;

        const dataSrcPc = this.thumbVideo.getAttribute('data-src-pc');
        const dataSrcMb = this.thumbVideo.getAttribute('data-src-mb');

        videoSrc = matchMedia.matches ? (dataSrcMb || dataSrcPc) : dataSrcPc;

        const player = await VidstackPlayer.create({
            target: this.thumbVideo,
            title: title,
            controls: false,
            playsInline: true,
            loop: true,
            src: videoSrc,
            autoPlay: true,
            muted: true,
            // poster: 'https://files.vidstack.io/sprite-fight/poster.webp',
            layout: new VidstackPlayerLayout({
                thumbnails: '',
            }),
        });
        const thumbInstance = player;
        const { canPlay } = thumbInstance.state;
        thumbInstance.subscribe(({ canPlay }) => {
            if (canPlay) {
                // console.log('canPlay');
                this.thumbVideo.classList.add('video-popup__thumb-video--can-play');
            }
        })
    }
}
customElements.define('video-popup', VideoPopup);
